import request from "@/utils/request";

export function getUserInfo() {
  return request({
    url: "/info",
    method: "get"
  });
}

export function uploadAvatar(file) {
  const formData = new FormData();
  formData.append("file", file);
  return request({
    url: "/info/avatar/upload",
    method: "post",
    data: formData
  });
}

export function completeUserInfo(avatar, gender, nickname) {
  return request({
    url: "/info/base/edit",
    method: "put",
    data: {
      avatar,
      gender,
      nickname
    }
  });
}

export function attentionUser(userId) {
  return request({
    url: `/relation/relation/${userId}/set`,
    method: "post",
    params: {
      type: 0,
      cid: userId
    }
  });
}

export function cancelAttentionUser(userId) {
  return request({
    url: `/relation/relation/${userId}/set`,
    method: "post",
    params: {
      type: 1,
      cid: userId
    }
  });
}

export function getFollowList() {
  return request({
    url: "/relation/follow/list",
    method: "get"
  });
}

export function getJMessageAuth() {
  return request({
    url: "/auth/jg",
    method: "get"
  });
}
